import { useState } from "react";
import { useSelector } from "react-redux";

import useScrollManager from "../Utils/ScrollManager";
import HeaderManager from "../Header/HeaderManager";
import FooterManager from "../Footer/FooterManager";
import { useCurrentRoute } from "../Routing/useCurrentRoute";

const Main = ({ children }) => {
  const [mainContent, setMainContent] = useState();
  const currentRoute = useCurrentRoute();

  const iFrameMode = useSelector(({ styling }) => styling.iFrameMode);
  // We don't display the header when the resource is shown in iFrame mode
  const displayHeader = !iFrameMode;
  // We only show the footer if the main content ref is set.
  const displayFooter = mainContent;

  useScrollManager({ preventScroll: currentRoute?.isModal });

  return (
    <>
      {displayHeader && <HeaderManager />}

      <main
        id="main"
        role="main"
        className="main-content"
        ref={setMainContent}
        data-main-container
      >
        {children}
      </main>

      {displayFooter && <FooterManager mainContent={mainContent} />}
    </>
  );
};

export default Main;
